import request from './api'

/*export async function requestKdGTP(kod_dog) {
    try {
        //var params = '?user_id=' + ui
        const result = await request('/api/plan/req-kd-gtp', 'POST', {kod_dog})

        if (result)
            return {
                isOk: true,
                result: result.result
            };
    }
    catch (e) {
        console.error(e)
        return {
            isOk: false,
            message: e.message
        };
    }
}*/

export async function getKdGtp(kod_dog) {
    try {
        //var params = '?user_id=' + ui
        const result = await request('/api/plan/get-kd-gtp', 'POST', {kod_dog})

        if (result)
            return {
                isOk: true,
                result: result.result
            };
    }
    catch (e) {
        console.error(e)
        return {
            isOk: false,
            message: e.message
        };
    }
}

export async function getGtpPlan(kod_gtp, dt_begin, dt_end, kod_dog) {
    try {
        const result = await request('/api/plan/get-gtp-plan', 'POST', {kod_gtp, dt_begin, dt_end, kod_dog})

        if (result)
            return {
                isOk: true,
                result: result.result,
                rpp: result.rpp || {},
                show_rpp: !!result.show_rpp,
                sent: result.sent_dates || []
            };
    }
    catch (e) {
        console.error(e)
        return {
            isOk: false,
            message: e.message
        };
    }
}

export async function updGtpPlan(id_gtp, dt, val, kod_dog) {
    try {
        const result = await request('/api/plan/update-gtp-plan', 'POST', {id_gtp, dt, val, kod_dog})
        if (result)
            return {
                isOk: true,
                result: result.message
            };
    }
    catch (e) {
        console.error(e)
        return {
            isOk: false,
            message: e.message
        };
    }
}

export async function copyPasteGTPPlan(id_gtp, dt_from, dt_to_start, dt_to_end, kod_dog) {
    try {
        const result = await request('/api/plan/copy-paste-gtp-plan', 'POST', {id_gtp, dt_from, dt_to_start, dt_to_end, kod_dog})
        if (result)
            return {
                isOk: true,
                result: result.message
            };
    }
    catch (e) {
        console.error(e)
        return {
            isOk: false,
            message: e.message
        };
    }
}

export async function getFileExcel(kdGtp, period1, period2, kod_dog) {

    try {
        const result = await request('/api/plan/get-gtp-excel', 'POST', {kod_gtp: kdGtp, dt_begin: period1, dt_end: period2, kod_dog})
        if (result)
            return {
                isOk: true,
                result
            };
    }
    catch (e) {
        console.error(e)
        return {
            isOk: false,
            message: e.message
        };
    }
}

export async function importGtpExcel(kod_gtp, kod_dog, file, correct) {
    try {
        const result = await request('/api/plan/import-gtp-excel', 'POST', {kod_gtp, kod_dog, file, correct})
        if (result)
            return {
                isOk: true,
                message: result.message,
                imported: result.imported,
                skipped: result.skipped
            };
    }
    catch (e) {
        console.error(e)
        return {
            isOk: false,
            message: e.message
        };
    }
}

export async function sendGtpPlan(kdGtp, period1, period2, kod_dog, correct, days) {

    try {
        const result = await request('/api/plan/send-gtp-plan', 'POST', {
            kod_gtp: kdGtp, dt_begin: period1, dt_end: period2, kod_dog, correct: !!correct, days
        })
        if (result)
            return {
                isOk: true,
                message: result.message,
                sent: result.sent || [],
                skipped_partial: result.skipped_partial || [],
                skipped_unchanged: result.skipped_unchanged || [],
            };
        return { isOk: false, message: 'Пустой ответ сервера' };
    }
    catch (e) {
        console.error(e)
        return {
            isOk: false,
            message: e.message
        };
    }
}

export async function getChartGtpPlanAnalitic(kod_gtp, ym, kod_dog, dt_begin, dt_end) {
    try {
        const result = await request('/api/plan/get-gtp-analitic', 'POST', {
            kod_gtp, ym, kod_dog, dt_begin, dt_end
        })

        if (result)
            return {
                isOk: true,
                result: result.result,
                rpp: result.rpp || {},
                show_rpp: !!result.show_rpp
            };
    }
    catch (e) {
        console.error(e)
        return {
            isOk: false,
            message: e.message
        };
    }
}

export async function getChartGtpPlanAnaliticFact(kod_gtp, ym, kod_dog) {
    try {
        const result = await request('/api/plan/req-gtp-fact', 'POST', {kod_gtp, ym, kod_dog})

        if (result)
            return {
                isOk: true,
                result: result.result
            };
    }
    catch (e) {
        console.error(e)
        return {
            isOk: false,
            message: e.message
        };
    }
}

export async function loadRppMonth(kod_gtp, kod_dog, month_offset) {
    try {
        const result = await request('/api/plan/load-rpp-month', 'POST', {kod_gtp, kod_dog, month_offset})
        if (result)
            return {
                isOk: true,
                message: result.message,
                filled: result.filled,
                has_data: result.has_data
            };
    }
    catch (e) {
        console.error(e)
        return {
            isOk: false,
            message: e.message
        };
    }
}

export async function clearGtpPlan(kod_gtp, kod_dog, dt_begin, dt_end) {
    try {
        const result = await request('/api/plan/clear-gtp-plan', 'POST', { kod_gtp, kod_dog, dt_begin, dt_end })
        if (result)
            return { isOk: true, ...result };
    }
    catch (e) {
        console.error(e)
        return { isOk: false, message: e.message };
    }
}

export async function getGtpAnaliticExcel(kod_gtp, ym, kod_dog) {
    try {
        const result = await request('/api/plan/get-gtp-analitic-excel', 'POST', {kod_gtp, ym, kod_dog})

        if (result)
            return {
                isOk: true,
                result
            };
    }
    catch (e) {
        console.error(e)
        return {
            isOk: false,
            message: e.message
        };
    }
}
